/** Fetches the recommended products of a product page, once the section comes into view. */
document.querySelectorAll('[data-product-recommendations]').forEach((container) => {
  const load = async () => {
    const response = await fetch(container.dataset.url);
    if (!response.ok) return;

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const recommendations = html.querySelector('[data-product-recommendations]');
    if (recommendations) container.innerHTML = recommendations.innerHTML;
  };

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      load();
    },
    { rootMargin: '400px' }
  );
  observer.observe(container);
});
